import { applyTokens, colorKeys } from "../../../utilities/applyTokens.js";
const getToggleButtonGroupTokens = (tokens) => {
    return {
        buttonGroup: tokens.component.buttonGroup,
        button: tokens.component.button,
        primary: tokens.component.buttonGroup.primary,
        secondary: tokens.component.buttonGroup.secondary,
        iconSize: tokens.semantic.iconSize,
        shadow: tokens.semantic.shadow,
    };
};
const toggleButtonGroup = (tokens) => {
    const { buttonGroup, button, primary, secondary, iconSize } = getToggleButtonGroupTokens(tokens);
    const { focusRing } = buttonGroup;
    return {
        MuiToggleButtonGroup: {
            defaultProps: {
                color: "primary",
            },
            styleOverrides: {
                root: {
                    borderRadius: buttonGroup.borderRadius.value,
                },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: ({ ownerState }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ padding: `0 ${buttonGroup.paddingHorizontal.value}`, gap: buttonGroup.gap.value, whiteSpace: "nowrap", borderRadius: buttonGroup.borderRadius.value, flex: "1 1 0", "&:focus": {
                        outline: focusRing.outline.value,
                        outlineOffset: focusRing.outlineOffset.value,
                        zIndex: 1,
                        ".MuiToggleButtonGroup-root &": {
                            borderRadius: buttonGroup.borderRadius.value,
                        },
                    } }, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === "primary" && Object.assign(Object.assign({ borderColor: primary.borderColor.value }, applyTokens(primary.default, colorKeys)), { "&:hover": Object.assign({}, applyTokens(primary.hover, colorKeys)), "&:active": Object.assign({}, applyTokens(primary.active, colorKeys)), "&.Mui-disabled": Object.assign({}, applyTokens(primary.disabled, colorKeys)), "&.Mui-selected": Object.assign(Object.assign({}, applyTokens(primary.selected.default, colorKeys)), { "&:hover": Object.assign({}, applyTokens(primary.selected.hover, colorKeys)), "&:active": Object.assign({}, applyTokens(primary.selected.active, colorKeys)), "&.Mui-disabled": Object.assign(Object.assign({}, applyTokens(primary.selected.disabled, colorKeys)), { borderRightColor: primary.disabled.borderColor.value, "&+.MuiToggleButton-root": {
                                borderLeftColor: primary.disabled.borderColor.value,
                            } }) }) }))), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === "secondary" && Object.assign(Object.assign({ borderColor: secondary.borderColor.value }, applyTokens(secondary.default, colorKeys)), { "&.Mui-disabled": Object.assign({}, applyTokens(secondary.disabled, colorKeys)), "&:hover": Object.assign({}, applyTokens(secondary.hover, colorKeys)), "&:active": Object.assign({}, applyTokens(secondary.active, colorKeys)), "&.Mui-selected": Object.assign(Object.assign({}, applyTokens(secondary.selected.default, colorKeys)), { "&:hover": Object.assign({}, applyTokens(secondary.selected.hover, colorKeys)), "&:active": Object.assign({}, applyTokens(secondary.selected.active, colorKeys)), "&.Mui-disabled": Object.assign({}, applyTokens(secondary.selected.disabled, colorKeys)) }) }))), ((!(ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) || (ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "medium") && {
                    height: buttonGroup.height.value,
                    fontSize: button.fontSize.value,
                })), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "small" && {
                    height: buttonGroup.small.height.value,
                    fontSize: button.small.fontSize.value,
                    fontWeight: button.small.fontWeight.value,
                })), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "large" && {
                    height: buttonGroup.large.height.value,
                    fontSize: button.large.fontSize.value,
                })), { "& > svg": {
                        flexShrink: 0,
                        width: iconSize.lg.value,
                        height: iconSize.lg.value,
                        fontSize: iconSize.lg.value,
                        lineHeight: iconSize.lg.value,
                    } })),
            },
        },
    };
};
export default toggleButtonGroup;
//# sourceMappingURL=toggleButtonGroup.js.map